const rolesSummary = (
  <div className="roles-positions-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">What is Software Engineering?</h3>
      <ul className="list-disc pl-6">
        <li>Writing code and designing systems to solve real-world problems</li>
        <li>Creating websites, apps, software</li>
        <li>Examples: video games, websites, social media apps, and airplane control systems</li>
      </ul>
    </div>
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Frontend Development</h3>
      <ul className="list-disc pl-6">
        <li>
          Focuses on visual and interactive aspects that users see and engage with
          <ul className="list-disc pl-6 mt-1">
            <li>Involves HTML, CSS, JavaScript/TypeScript</li>
            <li>Uses frameworks like React, Vue, or Angular</li>
            <li>Implements designs created by UI/UX engineers</li>
          </ul>
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Backend Development</h3>
      <ul className="list-disc pl-6">
        <li>
          Works "behind the scenes" of websites and applications
          <ul className="list-disc pl-6 mt-1">
            <li>Handles storing and retrieving user information</li>
            <li>Manages interactions with other services</li>
            <li>Ensures data security</li>
            <li>Provides information to the frontend for display</li>
          </ul>
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Fullstack Development</h3>
      <ul className="list-disc pl-6">
        <li>Combination of frontend and backend development roles</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How Internships are Advertised</h3>
      <ul className="list-disc pl-6">
        <li>Most internships use the general title "Software Engineer"</li>
        <li>Specific role (frontend, backend, fullstack) is often determined after hiring</li>
        <li>
          Other specialized roles (DevOps, infrastructure) exist but are less common for internships
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Learn more about additional roles</h3>
      <ul className="list-disc pl-6">
        <li>
          Descriptions of additional roles{' '}
          <a
            href="https://www.browserstack.com/guide/what-are-the-different-types-of-software-engineer-roles"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            here
          </a>
        </li>
      </ul>
    </div>
  </div>
);

export default rolesSummary;
